import * as React from "react";
import {
  AlertsIcon,
  DeviceManagementIcon,
  MobileLicensingIcon,
  RightIcon,
  QuickAlertIcon,
  HelpIcon,
} from "../../components/ui/icons";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "./dashboard.scss";
import useDashboard from "./useDashboard";
import { FLASHCAST_USER_GUIDE_URL, routes, Status } from "../../common/constants";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isSuccessResponse } from "../../common/utils";
import useNotification from "../../components/notification/useNotification";
import {
  sendQuickAlerts,
  selector as sendQuickAlertSelector,
} from "../alerts/quickAlerts/quickAlertRow/sendQuickAlertsSlice";
import {
  sendDasAlert,
  selector as sendDasAlertSelector,
} from "../alerts/dasAlertSlice";
import { IInitialSliceState } from "../../common/types/commonTypes";
import { useSpinner } from "../../customHooks";
import SendAlertConfirmationModal from "../alerts/quickAlerts/sendAlertConfirmation";
import { IGroupAlerts } from "../../common/types/alertsTypes";
import { useState } from "react";

const Dashboard = () => {
  const {
    activeAlertsNumber,
    quickAlertsData,
    quickAlertsNumber,
    isMimoAccount,
    approvalAlertsNumber,
    offlineDevicesNumber,
    offlineDevicesPercentage,
    licenseDetails,
    handleNavigation,
    quickAlertsStatus
  } = useDashboard();
  const IS_ARE_WORD: string = offlineDevicesNumber !== 1 ? "are" : "is";

  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  const today = new Date();
  const expireDate = new Date(licenseDetails?.expireDate);
  const creationDate = new Date(licenseDetails?.creationDate);

  const diffTime = expireDate.getTime() - today.getTime();
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const percentUsed = Math.round(
    (licenseDetails?.usedLicenseCount / licenseDetails?.totalLicenseCount) * 100
  );

  const status =
    daysLeft <= 0 ? "Expired" : daysLeft <= 7 ? "Expiring Soon" : "Active";

  const statusColor =
    status === "Expired"
      ? "#E53935"
      : status === "Expiring Soon"
      ? "#FB8C00"
      : "#43A047";

  const formatDate = (date) =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const handleActiveAlertsNavigation = () => {
      const params = new URLSearchParams({
        status: "Live",
        severity: "High",
      });

      handleNavigation(`${routes.alerts}?${params.toString()}`);
};

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const dispatch: any = useDispatch();

  const dispatchSendQuickAlerts = (action, payload) => {
    try {
      dispatch(action(payload)).then((response) => {
        if (isSuccessResponse(response.payload)) {
          showSuccessNotification(response.payload.message);
        } else {
          showWarningNotification(response.payload.response.data.message);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleQuickAlerts = (command) => {
    dispatchSendQuickAlerts(sendQuickAlerts, command);
  };

  const handleDasAlert = () => {

    const payload = {
        selectedGroups: [] 
    };

    dispatch(sendDasAlert(payload)).then((response) => {
      if (isSuccessResponse(response.payload)) {
        showSuccessNotification(response.payload.message);
      } else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
  };

  const sendDasAlertResponse: IInitialSliceState =
    useSelector(sendDasAlertSelector);
  const sendQuickAlertResponse: IInitialSliceState = useSelector(
    sendQuickAlertSelector
  );

  useSpinner(sendDasAlertResponse.status);
  useSpinner(sendQuickAlertResponse?.status);

  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [selectedAlert, setSelectedAlert] = React.useState<any>(null);
  const [modalGroups, setModalGroups] = useState<IGroupAlerts[]>([]);

  const handleAlertButtonClick = (alert) => {
    setModalGroups(alert.groups || []);
    setSelectedAlert(alert);
    setShowConfirmation(true);
  };

  const handleConfirmSend = (updatedGroups: IGroupAlerts[]) => {
    dispatchSendQuickAlerts(sendQuickAlerts, {
      ...selectedAlert,
      groups: updatedGroups,
    });
    setShowConfirmation(false);
    setSelectedAlert(null);
  };

  const handleCancelSend = () => {
    setShowConfirmation(false);
    setSelectedAlert(null);
  };

  // const EVACUATE_MSG = "Evacuation Emergency:\nThere is an Emergency in the building!\nPlease evacuate the building immediately per your evacuation plan!";
  // const STAY_MSG = "Stay in Place Emergency:\nThere is an Emergency in the building that requires you to stay in place\nStay in classrooms and lock the doors!";
  // const ALL_CLEAR_MSG = "All Clear Notice:\nEverything is back to Normal.\nPlease go back to your normal operation.";

  return (
    <div className="dashboard">
      <div className="dashboard-heading">
        <div className="heading-content">
          <h1>{isMobile ? "Send Quick Alerts" : "Dashboard"}</h1>
          
          <OverlayTrigger
            placement="left" 
            overlay={<Tooltip id="dashboard-help-tooltip">View User Guide</Tooltip>}
          >
            <div 
              className="help-icon-wrapper"
              onClick={() => handleNavigation(routes.userGuide)}
            >
              <HelpIcon />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      {isMobile ? (
        <div>
          <div className="dashboard-body">
            <div className="dashboard-alerts-content">
              <div className="Alerts-heading">
                <AlertsIcon />
                <h1>Alerts</h1>
              </div>
              <div className="quick-alerts-btn">
                {isMimoAccount && (
                  <Button onClick={handleDasAlert}>Send DAS Alert</Button>
                )}
               { quickAlertsNumber === 0 &&
                <div>No Quick Alerts available.</div>}
                {quickAlertsData.map((alert) => (
                  <Button
                    key={alert.alertButtonName}
                    onClick={() => handleAlertButtonClick(alert)}
                  >
                    {alert.alertButtonName}
                  </Button>
                ))}
              </div>
            </div>
          </div>
          {showConfirmation && (
            <SendAlertConfirmationModal
              show={showConfirmation}
              onConfirm={handleConfirmSend}
              onCancel={handleCancelSend}
              alertTitle={selectedAlert.alertTitle}
              initialGroups={modalGroups}
            />
          )}
        </div>
      ) : (
        <div className="dashboard-body">
          <div className="dashboard-alerts-content">
            <div className="Alerts-heading">
              <AlertsIcon />
              <h1>Alerts</h1>
            </div>
            <div className="alerts-content">
              <div className="alert-body">
                <div className="alerts-count">{activeAlertsNumber}</div>
                <div className="alerts-text">Active high severity alerts</div>
                <div className="alerts-btns">
                  <RightIcon />
                  <span
                    className="pointer-cursor"
                    onClick={handleActiveAlertsNavigation}
                  >
                    View the active alerts
                  </span>
                </div>
              </div>

              <div className="alert-body">
                <div className="alerts-count">{approvalAlertsNumber}</div>
                <div className="alerts-text">Alerts that need approval</div>
                <div className="alerts-btns">
                  <RightIcon />
                  <span
                    className="pointer-cursor"
                    onClick={() => handleNavigation(routes.alertsApproval)}
                  >
                    Approve the alerts
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="dashboard-alerts-content">
            <div className="Alerts-heading">
              <QuickAlertIcon />
              <h1>Quick Alerts</h1>
            </div>
            <div className="alerts-content">
              <div className="alert-body">
                <div className="alerts-count">{quickAlertsStatus==Status.PENDING?`Loading...`:quickAlertsNumber}</div>
                <div className="alerts-text">Quick alerts are ready to go!</div>
                <div className="alerts-btns">
                  <RightIcon />
                  <span
                    className="pointer-cursor"
                    onClick={() => handleNavigation(routes.quickAlerts)}
                  >
                    View Quick alerts
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="dashboard-deviceManagement-content">
            <div className="deviceManagement-heading">
              <DeviceManagementIcon />
              <h1>Device Management</h1>
            </div>
            <div className="deviceManagement-content">
              <div className="deviceManagement-body">
                <div className="deviceManagement-title">Offline Devices</div>
                <div className="deviceManagement-graph">
                  <CircularProgressbar
                    value={offlineDevicesPercentage}
                    text={`${offlineDevicesPercentage}%`}
                  />
                  <div className="alerts-text">
                    There {IS_ARE_WORD} {offlineDevicesNumber} device
                    {offlineDevicesNumber !== 1 ? "s" : ""} that {IS_ARE_WORD}{" "}
                    currently offline
                  </div>
                </div>

                <div className="deviceManagement-btns">
                  <RightIcon />
                  <span
                    className="pointer-cursor"
                    onClick={() => handleNavigation(routes.deviceManagement)}
                  >
                    View the offline devices
                  </span>
                </div>
              </div>

              {/* Commenting below code as right now we are not supporting device version, will use in future if needed */}
              {/* <div className='deviceManagement-body'>
                            <div className='deviceManagement-title'>Device Update</div>
                            <div className='deviceManagement-graph'>
                                <CircularProgressbar value={offlineDevicesPercentage} text={`${offlineDevicesPercentage}%`} />
                                <div className='alerts-text'>There are 17 devices that have outdated version</div>
                            </div>

                            <div className='deviceManagement-btns'>
                                <RightIcon />
                                <span>Click to update to latest version</span>
                            </div>
                        </div> */}
            </div>
          </div>
          <div className="dashboard-mobileLicense-content">
            <div className="mobileLicense-heading">
              <MobileLicensingIcon />
              <h1>Licenses</h1>
            </div>

            {!licenseDetails ? (
              <div className="mobileLicense-card">
                <div className="mobileLicense-body">
                  <div className="mobileLicense-title">License Status</div>
                  <div className="mob-license-status-msg">
                    License is <b style={{ color: "#E53935" }}>Expired</b> or
                    not available.
                  </div>
                  <div className="mob-license-contact-info">
                    Please contact the Mimo Sales Team for assistance at{" "}
                    <a href="mailto:sales@mimomonitors.com">
                      sales@mimomonitors.com
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mobileLicense-card">
                <div className="mobileLicense-body">
                  <div className="mobileLicense-title">
                    Mobile License Overview
                  </div>

                  <div className="mobileLicense-details">
                    <div className="license-progress">
                      <CircularProgressbar
                        value={percentUsed}
                        text={`${percentUsed}%`}
                        styles={buildStyles({
                          pathColor: licenseDetails?.isActive
                            ? statusColor
                            : "#BDBDBD",
                          trailColor: "#eee",
                          textColor: licenseDetails?.isActive
                            ? "#333"
                            : "#9E9E9E",
                          textSize: "22px",
                          pathTransitionDuration: 0.5,
                        })}
                      />
                    </div>

                    <div className="license-info">
                      <div>
                        <b>{licenseDetails?.usedLicenseCount}</b> /{" "}
                        {licenseDetails?.totalLicenseCount} Licenses Used
                      </div>

                      <div
                        style={{
                          color: licenseDetails?.isActive
                            ? statusColor
                            : "#9E9E9E",
                          fontWeight: 600,
                        }}
                      >
                        {licenseDetails?.isActive ? status : "Disabled"}
                      </div>

                      {status === "Expired" ? (
                        <div className="mob-license-status-msg">
                          <b style={{ color: "#E53935" }}>
                            License is Expired.
                          </b>
                        </div>
                      ) : licenseDetails?.isActive ? (
                        <div>
                          Expires in{" "}
                          <b>{daysLeft > 0 ? `${daysLeft} days` : "Expired"}</b>
                        </div>
                      ) : (
                        <>
                          <div className="mob-license-status-msg">
                            Your organization's license has been disabled.
                          </div>
                          <div className="mob-license-contact-info">
                            Please contact the Mimo Sales Team for assistance at{" "}
                            <a href="mailto:sales@mimomonitors.com">
                              sales@mimomonitors.com
                            </a>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="mobileLicense-footer">
                    <span>Created: {formatDate(creationDate)}</span>
                    <span>Expiry: {formatDate(expireDate)}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
